import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

interface HubNodeProps {
  data: {
    label: string;
    description?: string;
  };
}

function HubNode({ data }: HubNodeProps) {
  return (
    <div className="px-4 py-2 shadow-md rounded-md border-2 bg-blue-50 border-blue-400">
      <div className="flex">
        <div className="rounded-full w-12 h-12 flex justify-center items-center bg-blue-100">H</div>
        <div className="ml-2">
          <div className="text-lg font-bold text-blue-700">{data.label}</div>
          {data.description && <div className="text-gray-500">{data.description}</div>}
        </div>
      </div>

      <Handle type="target" position={Position.Top} className="w-4 h-4 !bg-blue-500" />
      <Handle type="source" position={Position.Bottom} className="w-4 h-4 !bg-blue-500" />
    </div>
  );
}

export default memo(HubNode);
